import { useEffect, useState } from 'react';
import useEcho from './useEcho';
import { SOLICITUD_ALTERNATIVAS_API } from '../views/MainLayout/components/shared/services/solicitudAlternativas';

export default function useSolicitudAlternativasPendientesListener(userId) {
    const [pendientesCount, setPendientesCount] = useState(0);
    const echo = useEcho();

    useEffect(() => {
        if (!userId) {
            return;
        }

        const refreshCount = () =>
            SOLICITUD_ALTERNATIVAS_API.getPendientesCount()
                .then((resp) => setPendientesCount(resp.data))
                .catch(console.error);

        refreshCount();

        if (!echo) {
            return;
        }

        const channel = echo.private(`solicitud-alternativas.${userId}`);

        channel.listen('.SolicitudAlternativasContadorActualizado', refreshCount);

        return () => {
            channel.stopListening(
                '.SolicitudAlternativasContadorActualizado',
                refreshCount,
            );
        };
    }, [echo, userId]);

    return pendientesCount;
}
